import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useAppContext } from '@provider/app-context';
import { ErrorMessage } from '../../../atoms/Error/Error.js';
import { getStatusForProductQuery } from '../api.get-status.js';
import { jsx } from 'react/jsx-runtime';

function StatusErrorMessage(props) {
  const queryClient = useQueryClient();
  const [isLoading, setLoading] = useState(false);
  const productId = useAppContext(state => state.product?.isbn);
  const retry = () => {
    const query = getStatusForProductQuery(productId);
    const isFetching = queryClient.isFetching({
      queryKey: query.queryKey
    });

    // If our status isn't an array or undefined, that means it is a promise
    // and hence we're already attempting to refetch our status. Bail out!
    if (isFetching) {
      return;
    }
    setLoading(true);
    queryClient.fetchQuery(query).catch(() => {
      setLoading(false);
    });
  };
  return /*#__PURE__*/jsx(ErrorMessage, {
    ref: props.ref,
    isLoading: isLoading,
    onRetry: retry
  });
}

export { StatusErrorMessage };
//# sourceMappingURL=message.error.js.map
